module.exports = __webpack_public_path__ + "img/multihul-white.ef450aa7.svg";